<template>
	<div id="userh">
		<userMenu></userMenu>
		<div class="userh">
			<div class="userh-box">
			<el-table :data="userData" style="width: 100%">
				<el-table-column prop="id" label="ID" width="70">
				</el-table-column>
				<el-table-column prop="account" label="账号">
				</el-table-column>
				<el-table-column prop="account" label="等级">
					<template slot-scope="scope">
						<el-tag size="small" type="primary">{{lvData[scope.row.level]}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="昵称">
				</el-table-column>
				<el-table-column prop="avatar" label="头像">
					<template slot-scope="scope">
						<img :src="scope.row.avatar" width="20" style="position: relative;top: 4px;border-radius: 3px;">
					</template>
				</el-table-column>
				<el-table-column prop="wechat" label="微信">
				</el-table-column>
				<el-table-column prop="valid_time" label="有效期">
				</el-table-column>
				<el-table-column prop="create_time" label="注册时间">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" effect="dark" @click="editItem(scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" effect="dark">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			</div>
		</div>
		<el-dialog title="编辑会员信息" :visible.sync="editPup" width="500px">
			<div class="pup-wd">
				<el-input placeholder="请输入内容" v-model="theAccount" size="small">
					<template slot="prepend">会员</template>
				</el-input>
				<el-input placeholder="请输入内容" v-model="theNick" size="small">
					<template slot="prepend">昵称</template>
				</el-input>
				<el-select v-model="lvId" placeholder="请选择" size="small" style="width: 100%;">
				    <el-option v-for="item in leves" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
		
			<span slot="footer" class="dialog-footer">
				<el-button @click="editPup = false" size="small">取 消</el-button>
				<el-button type="primary" @click="setInfo" size="small">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import userMenu from '@/page/public/userMenu'
	import api from '@/api/api'
	export default {
		components: {
			userMenu: userMenu
		},
		data() {
			return {
				page: 1,
				rows: 10,
				userData: [],
				lvData: ['', '注册用户', '月费会员', '特邀会员', '年费会员', '管理员', '超级管理员'],
				editPup:false,
				theAccount:'',
				theNick:'',
				lvId:'',
				theId:'',
				leves:[{id:1,name:'注册用户'},{id:2,name:'月费会员'},{id:3,name:'特邀会员'},{id:4,name:'年费会员'},{id:5,name:'管理员'},{id:6,name:'超级管理员'}]
			}
		},
		methods: {
			setInfo(){
				let params = {
					token: api.getCookie('token'),
					id:this.theId,
					lv:this.lvId
				}
				api.setUserLv(params).then(res=>{
					if(res.code == 200){
						this.getUserList();
						this.$message.success(res.msg);
						this.editPup = false;
					}
				})
			},
			editItem(data){
				this.editPup = true;
				this.theAccount = data.account;
				this.theNick = data.nickname;
				this.lvId = parseInt(data.level);
				this.theId = data.id;
			},
			getUserList() {
				let params = {
					token: api.getCookie('token'),
					page: this.page,
					rows: this.rows
				}
				api.getUserList(params).then(res => {
					this.userData = res.data.list;
				})
			}
		},
		created() {
			this.getUserList()
		}
	}
</script>

<style>
	.pup-wd .el-input{
		margin-bottom: 10px;
	}
	.userh-box{
		position: relative;
		top: 20px;
		margin: 0 20px;
		padding: 20px;
		background-color: #fff;
		border-radius: 10px;
	}
	#userh {
		width: 100%;
		min-height: 100vh;
		background-color: var(--bg3);
		box-sizing: border-box;
		padding-left: 220px;
	}
</style>



// WEBPACK FOOTER //
// src/page/user.vue